import type { ButtonHTMLAttributes, ReactNode } from 'react';

export function Panel({
  title,
  action,
  children,
  className,
}: {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={['panel', className].filter(Boolean).join(' ')}>
      {(title || action) && (
        <div className="panel__head">
          {title && <h3 className="panel__title">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Empty({ title, children }: { title: ReactNode; children?: ReactNode }) {
  return (
    <div className="empty" role="status">
      <b>{title}</b>
      {children && <span>{children}</span>}
    </div>
  );
}

export function Tile({
  label,
  value,
  sub,
  tone,
  pressed,
  ...rest
}: {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  tone?: 'ready';
  pressed?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" className={`tile${tone ? ` tile--${tone}` : ''}`} aria-pressed={pressed} {...rest}>
      <span className="tile__k">{label}</span>
      <span className="tile__v">{value}</span>
      {sub && <span className="tile__s">{sub}</span>}
    </button>
  );
}

export function Spinner({ label }: { label: string }) {
  return (
    <div className="center" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <span className="muted">{label}</span>
    </div>
  );
}

export function Field({
  label,
  hint,
  error,
  children,
}: {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
}) {
  return (
    <label className="field">
      <span>{label}</span>
      {children}
      {error ? <small className="err">{error}</small> : hint ? <small>{hint}</small> : null}
    </label>
  );
}
